import { createContext, useContext, useState, useCallback } from "react";

const CartUICtx = createContext(null);

/**
 * Controls the slide-over cart drawer + exposes the merchant's `skip_cart`
 * preference so "Add to cart" can jump straight to checkout when enabled.
 */
export function CartUIProvider({ skipCart = false, children }) {
  const [cartOpen, setCartOpen] = useState(false);
  const openCart = useCallback(() => setCartOpen(true), []);
  const closeCart = useCallback(() => setCartOpen(false), []);
  return (
    <CartUICtx.Provider value={{ cartOpen, openCart, closeCart, skipCart }}>
      {children}
    </CartUICtx.Provider>
  );
}

export const useCartUI = () => useContext(CartUICtx) || { cartOpen: false, openCart: () => {}, closeCart: () => {}, skipCart: false };
